import { useMutation, UseMutationOptions } from 'react-query';
import { mutateProtestOverride } from './fptpProtestOverride';
import { TProtestOverrideBody } from './fptpProtestOverride.types';

export const useMutationProtestOverride = (
  options?: UseMutationOptions<unknown, unknown, TProtestOverrideBody>
) => useMutation((data) => mutateProtestOverride(data), options);
